import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "gene-attribute-view-container" }
const _hoisted_2 = { class: "left-side" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "sub-title" }, "Exploration", -1)
const _hoisted_4 = { class: "select-container" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "select-label" }, " Genes/Features ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", { class: "sub-title" }, "Style", -1)
const _hoisted_7 = { class: "select-container" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "select-label" }, " Marker Size ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h2", { class: "sub-title" }, "Selection", -1)
const _hoisted_10 = { class: "select-container" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "select-label" }, " Cell name ", -1)
const _hoisted_12 = { class: "right-side" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_GeneAttributeViewPlot = _resolveComponent("GeneAttributeViewPlot")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_el_select_v2, {
          modelValue: _ctx.selectedGeneFeature,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedGeneFeature) = $event)),
          class: "select",
          filterable: "",
          remote: "",
          "remote-method": _ctx.geneFeatureFilter,
          options: _ctx.geneFeatureList,
          onChange: _ctx.getGeneAttributeViewData
        }, null, 8, ["modelValue", "remote-method", "options", "onChange"])
      ]),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_el_select, {
          modelValue: _ctx.markerSize,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.markerSize) = $event)),
          class: "select",
          filterable: "",
          onChange: _ctx.markerSizeChangeCallback
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.markerSizeList, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item,
                label: String(item),
                value: item
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "onChange"])
      ]),
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createVNode(_component_el_select, {
          modelValue: _ctx.selectCellNames,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectCellNames) = $event)),
          class: "select",
          multiple: "",
          filterable: "",
          onChange: _ctx.selectChangeCallback
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cellNameList, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: String(item.cell_name),
                label: String(item.cell_name),
                value: String(item.cell_name)
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "onChange"])
      ])
    ]),
    _createVNode(_component_el_divider, {
      direction: "vertical",
      class: "mid-separator"
    }),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_GeneAttributeViewPlot, { ref: "attributePlot" }, null, 512)
    ])
  ]))
}